import type { DatasetZoomModalProps } from "./dataset-zoom-modal.type";

import classNames from "classnames";

import { DatasetWrapper } from "@/modules/dataset/dataset-wrapper";
import { ModalFullscreen } from "@/ui/modal-fullscreen";

const DatasetZoomModal = ({
  datasetType,
  loading,
  className,
  children,
  ...modalProps
}: DatasetZoomModalProps) => {
  return (
    <ModalFullscreen
      footer={null}
      closable={false}
      {...modalProps}
      className={classNames(
        "dataset-zoom-modal",
        `${datasetType}-zoom-modal`,
        className
      )}
    >
      <DatasetWrapper datasetType={datasetType} loading={loading}>
        {children}
      </DatasetWrapper>
    </ModalFullscreen>
  );
};

export default DatasetZoomModal;
